import { getJson } from "../../auth/utils/getJson.js";

/** GET /api/filelogs/structure/logs?startDate=...&endDate=... */
export function fetchStructureLogs({ start, end }, signal) {
  const params = new URLSearchParams();
  if (start) params.set("startDate", start);
  if (end) params.set("endDate", end);
  params.set("_", Date.now()); 

  return getJson(`/api/filelogs/structure/logs?${params.toString()}`, { signal }).then(
    (json) => (Array.isArray(json) ? json : [])
  );
}
